export default __webpack_public_path__ + "static/media/filter-black.52b818f0.svg";